import { useController, useFormContext, useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CountrySelectorFormSchema } from "@/models/patient"
import { CitySelector as CitySelectorCommon } from "@/modules/inbound-wizard/components/contact/address/city-selector"

const CitySelector = (props: React.HTMLAttributes<HTMLParagraphElement> & { required?: boolean }) => {
  const { t } = useTranslation()
  const form = useFormContext<CountrySelectorFormSchema>()
  const {
    setValue,
    control,
    trigger,
    formState: { errors: formErrors },
  } = form

  const countryField = useWatch({ control, name: "country" })
  const { field: city } = useController({ name: "city", control })

  return (
    <CitySelectorCommon
      {...props}
      className="col-span-2"
      countryIsoCode={countryField}
      value={city.value}
      onSelect={(data) => {
        if (data) {
          setValue("postalCode", data.postalCode ?? "", { shouldValidate: true, shouldDirty: true })
        }
      }}
      error={t(formErrors?.city?.message || "")}
      onChange={(value) => {
        city.onChange(value)
        trigger("city")
      }}
    />
  )
}

export { CitySelector }
